import React, { Component } from 'react';
import AuthService from '../services/auth';
import Api from '../services/api';
import { withRouter } from 'react-router-dom';
import './magnets.css';
import withAuthorization from '../components/withAuthorization';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import * as routes from '../constants/routes';
import PaymentMethods from '../components/PaymentMethods';

class Magnets extends Component {

  constructor(props) {
    super(props);

    this.state = {
      chosenMethod: 'stripe',
      chosenOption: {
        key: '1_magnet',
        price: 4.9,
      },
      options: {
        '1_magnet': {
          key: '1_magnet',
          price: 4.9,
          discountPrice: 0,
          name: '1 x 1 magnet for 24 hours',
          type: '(discount price)',
          isDiscount: false,
        },
        'test': {
          key: 'test',
          price: 4.9,
          discountPrice: 1,
          name: 'discounted 1 x 1 magnet for 24 hours',
          type: '(discount price)',
          isDiscount: true,
        },
        '5_magnet': {
          key: '5_magnet',
          price: 14.9,
          discountPrice: 0,
          name: '5 x 1 magnet for 24 hours',
          type: '(discount price',
          isDiscount: false,
        }
      },
    };
  }

  componentDidMount() {
    const { setCurrentPage } = this.props;
    if(!AuthService.isLoggedIn()) {
      this.props.history.push(routes.JOIN);
    } else {
      (new Api()).get('/magnet-options', {}, AuthService.getAuthCookie())
        .then(response => {
          this.setState({
            options: response.options,
            chosenOption: response.options['1_magnet'],
          });
        });
      setCurrentPage(routes.MAGNET);
    }
  }

  handleRadioChange(value) {
    const { options } = this.state;
    this.setState({
      chosenOption: {
        key: value,
        price: (options[value].isDiscount)?options[value].discountPrice:options[value].price,
      },
    });
  }

  handleMethodChange(method) {
    this.setState({
      chosenMethod: method,
    });
  }

  render() {
    const { chosenOption, chosenMethod, options } = this.state;
    const { ucdUser } = this.props;
    return (
      <div className="container">
        {AuthService.isLoggedIn() && <div className="row">
          <div className="col col-12 magnets">
            <div className="intro">
              <p className={'first-line'}>Hey <span className={'bold'}>{ucdUser.name}</span>,</p>
              <p>YOu want more attention? use magnets!</p>
            </div>
            <div className="sub-text">
              <p className={'uppercase'}>Use a magnet , it will boost you on the site for 24  hours , all members will see your profile !!</p>
              <p className="bold">*PROMO ACTION – now discount</p>
              <p className="lowercase">*For limited time only</p>
            </div>
            <div className="payment">
              <div className="payment-options">
                {Object.keys(options).map(key => (
                  <div
                    key={options[key].key}
                    className="payment-option"
                    onClick={() => {this.handleRadioChange(options[key].key)}}
                  >
                    <div className="payment-option__checkbox">
                      <input
                        id={options[key].key}
                        type="radio"
                        name={'chosenOption'}
                        value={options[key].key}
                        onChange={(e) => {this.handleRadioChange(e.target.value);}}
                        checked={chosenOption.key === options[key].key}
                      />
                      <label htmlFor={options[key].key} />
                    </div>
                    <div className="payment-option__meta">
                      <div className="payment-option__name">
                        {options[key].name}
                      </div>
                      <div className="payment-option__price">
                        &#36;{(options[key].isDiscount)?options[key].discountPrice.toFixed(2):options[key].price.toFixed(2)}
                      </div>
                      {options[key].isDiscount === '1' &&
                      <div className="payment-option__price--striked">
                        &#36;{options[key].price.toFixed(2)}
                      </div>}
                      {options[key].isDiscount === '1' &&
                      <div className="payment-option__type">
                        {options[key].type}
                      </div>}
                    </div>
                  </div>
                ))}
              </div>
              <PaymentMethods
                transactionType={'magnet'}
                ucdUser={ucdUser}
                price={chosenOption.price}
                chosenProduct={chosenOption.key}
                method={chosenMethod}
                onMethodChange={(method) => {this.handleMethodChange(method)}}
              />
            </div>
          </div>
        </div>}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ucdUser: state.sessionState.ucdUser,
  authUser: state.sessionState.authUser,
});

const mapDispatchToProps = (dispatch) => ({
  onSetAuthUser: (authUser, ucdUser) => dispatch({ type: 'AUTH_USER_SET', authUser, ucdUser }),
  setCurrentPage: (page) => dispatch({ type: 'SET_CURRENT_PAGE', page }),
});

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Magnets);


// WEBPACK FOOTER //
// ./src/pages/magnets.js